var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAirplane = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 79,
    viewBox: "0 0 102 79",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1218 63.5848L47.2171 50.8834C46.6414 50.6958 46.3378 50.1096 46.5402 49.5762C46.7426 49.0428 47.3752 48.7615 47.9509 48.9491L84.5403 60.8944L98.9193 5.14165L6.71185 34.1317L33.534 43.0878C34.1097 43.2812 34.407 43.8673 34.1982 44.4007C33.9895 44.9341 33.3569 45.2096 32.7812 45.0162L0 34.0731L102 2L86.1155 63.5848H86.1218Z",
    fill: "#5A2FDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6128 79.0001L31.9082 43.5743L99.8618 2.70337L101.228 4.30936L48.3494 50.6607C47.9066 51.0475 47.2044 51.0299 46.7869 50.6196C46.3694 50.2093 46.3884 49.5587 46.8312 49.1719L90.8916 10.5517L34.4133 44.518L41.7198 74.2524L58.8759 53.2689C59.2428 52.8176 59.9386 52.7297 60.4257 53.0697C60.9128 53.4096 61.0077 54.0543 60.6408 54.5056L40.6128 78.9942V79.0001Z",
    fill: "#5A2FDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1631 77.6519C41.0809 77.6519 41.005 77.6461 40.9227 77.6285C40.3281 77.5054 39.9485 76.9603 40.0814 76.4035L46.5023 49.6935C46.6351 49.1425 47.2297 48.7909 47.8244 48.914C48.419 49.0371 48.7986 49.588 48.6657 50.139L42.2449 76.8489C42.131 77.3237 41.6755 77.6519 41.1631 77.6519Z",
    fill: "#5A2FDE"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAirplane, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Airplane.37230c2e.svg";
export { ForwardRef as ReactComponent };